import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JobCatsOne } from '../vacancy-data.component';
import { jobPath } from '../vacancy-format';

@Injectable({ providedIn: 'root' })
export class JobsNavigationService {
  constructor(private readonly router: Router) {}

  public navigateToJob(job: Pick<JobCatsOne, 'id' | 'title'>): void {
    this.router.navigateByUrl(jobPath(job));
  }

  public getJobLocation(job: Pick<JobCatsOne, 'location'>): string {
    return job?.location?.city || 'Nederland';
  }

  public getJobSalary(job: Pick<JobCatsOne, 'salary'>): string {
    const s = job?.salary;
    if (!s) return '';
    if (s.min && s.max) {
      return `€${s.min.toLocaleString('nl-NL')} - €${s.max.toLocaleString('nl-NL')}`;
    }
    if (s.static) {
      return `€${s.static.toLocaleString('nl-NL')}`;
    }
    return '';
  }
}
